import React from "react"
import ZdqConnectorSetup from "../../components/ZdqConnectorSetup"
import { AWS_S3 } from "../../Constants"

function ZdqAwsS3Connector() {
    return <ZdqConnectorSetup vendor={AWS_S3}></ZdqConnectorSetup>
}

export default ZdqAwsS3Connector 